import React, { Fragment } from 'react';
import PaqueteResumen from './precio-resumen';
import { usePriceFromDetails } from '../../hooks/packages';

const notaDolar = 'No aplica impuesto pais para pagos en moneda extranjera.';
const notaPesos = 'LOS PRECIOS PARA LOS VIAJES INTERNACIONALES SON EN DOLARES ESTADOUNIDENSES EXPRESADOS EN PESOS ARGENTINOS AL TIPO DE CAMBIO DEL DIA DE PAGO DE LA RESERVA.';

const Resumen = ({ paquete }) => {
  const [getPriceInformation, getFinalPrice] = usePriceFromDetails();
  const priceInformation = getPriceInformation();
  const finalPrice = getFinalPrice(true, 2, false);
  const labelPrice = `Precio total pagando en ${priceInformation.moneda}`;
  const mensaje = parseInt(paquete.proveedorId) !== 10 && parseInt(paquete.proveedorId) !== 5
    ? paquete.salidas[0].precios.mensaje
    : '';

  const notaRequeridaPesos = (
    <Fragment>
      <b>{`${mensaje !== '' ? `${mensaje != null && mensaje.toUpperCase()}\n` : ''}`}</b>
      {notaPesos}
    </Fragment>
  );

  return (
    <PaqueteResumen
      labelPrice={labelPrice}
      finalPrice={finalPrice}
      priceInformation={priceInformation}
      note={priceInformation.moneda === 'ARS' ? notaRequeridaPesos : ''}
    />
  );
};

export default Resumen;

